// extracted by mini-css-extract-plugin
module.exports = {"enabled":"ClientViewTable_enabled__1Xlzo","disabled":"ClientViewTable_disabled__2DGS8"};